import { render } from "./AttachmentsView.vue?vue&type=template&id=ac5329ae&scoped=true"
import script from "./AttachmentsView.vue?vue&type=script&lang=js"
export * from "./AttachmentsView.vue?vue&type=script&lang=js"

import "./AttachmentsView.vue?vue&type=style&index=0&id=ac5329ae&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5329ae"],['__file',"src/components/cases/AttachmentsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac5329ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac5329ae', __exports__)) {
    console.log('reload')
    api.reload('ac5329ae', __exports__)
  }
  
  module.hot.accept("./AttachmentsView.vue?vue&type=template&id=ac5329ae&scoped=true", () => {
    console.log('re-render')
    api.rerender('ac5329ae', render)
  })

}


export default __exports__